import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './style.scss';

const SortArrows = ({ sortDirection, onClick }) => {
  const sortArrowsClasses = classNames('uni-data-table__sort-arrows', {
    [`uni-data-table__sort-arrows--${sortDirection}`]: sortDirection,
  });

  return (
    <div className="uni-data-table__sort-arrows-container">
      <svg
        onClick={onClick}
        className={sortArrowsClasses}
        xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12"
      >
        <path
          className="uni-data-table__sort-arrows-up"
          d="M.1 4.3L3.6.7a.5.5 0 0 1 .8 0l3.5 3.6a.5.5 0 0 1-.4.8h-7a.5.5 0 0 1-.4-.8z"
        />
        <path
          className="uni-data-table__sort-arrows-down"
          d="M7.9 7.7l-3.5 3.6a.5.5 0 0 1-.8 0L.1 7.7A.5.5 0 0 1 .5 7h7a.5.5 0 0 1 .4.8z"
        />
      </svg>
    </div>
  );
};

SortArrows.propTypes = {
  sortDirection: PropTypes.string,
  onClick: PropTypes.func,
};

export default SortArrows;



// WEBPACK FOOTER //
// ./src/__partials/sort-arrows/index.jsx